import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Divider,
} from "@mui/material";
import _ from "lodash";
import { withStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const computeValues = (template, values) => {
  return Object.keys(values).reduce((computed, key) => {
    const templateOptions = _.find(template.template_options, {
      optionName: key,
    });

    if (templateOptions) {
      const selectedOption = _.find(templateOptions.optionValues, {
        value: values[key],
      });
      computed[key] = _.get(selectedOption, "name", values[key]);
    } else {
      computed[key] = values[key];
    }

    return computed;
  }, {});
};

const OfferPreview = ({
  template,
  imagePreviewUrl,
  customValues,
  classes,
  shortDescription,
}) => {
  const titleTemplate = _.template(template.title_template);
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <CardMedia className={classes.cardMedia} image={imagePreviewUrl} />
        <CardContent className={classes.cardContent}>
          <Typography className={classes.title}>
            {titleTemplate(computeValues(template, customValues))}
          </Typography>
          <Typography variant="caption">{shortDescription}</Typography>
        </CardContent>
        <Divider />
        {/* <CardActions className={classes.cardActions}>
          <AddCircle className={classes.addCircle} />
          <Typography variant="caption">Redeem</Typography>
        </CardActions> */}
      </Card>

      <Typography className={classes.previewText}>
        {t("offer_create.offer_preview_title")}
      </Typography>
    </div>
  );
};

OfferPreview.defaultProps = {
  shortDescription: "",
};

OfferPreview.propTypes = {
  template: PropTypes.object.isRequired,
  imagePreviewUrl: PropTypes.string.isRequired,
  customValues: PropTypes.object,
  classes: PropTypes.object.isRequired,
  shortDescription: PropTypes.string,
};

const styles = (theme) => ({
  container: {
    marginLeft: "1rem",
  },
  card: {
    maxWidth: 345,
  },
  cardMedia: {
    height: 160,
  },
  title: {
    fontWeight: 600,
  },
  addCircle: {
    color: theme.palette.grey[700],
    fontSize: 16,
    margin: 0,
  },
  cardContent: {
    padding: theme.spacing(1),
  },
  cardActions: {
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
  previewText: {
    fontWeight: "bold",
    marginTop: theme.spacing(1.25),
  },
});

export default withStyles(styles)(OfferPreview);
